export default "__VITE_ASSET__Dg64RTKW__"